<template>
  <purchase-tracking v-if="!!tracking" :items="tracking.items" :total="tracking.total" :requested-units="purchase.units.requested" :completed-units="purchase.units.completed"/>
  <purchase-manufacturer-info v-if="!!purchase && purchase.end_customer" :purchase="purchase" />
  <purchase-summary v-if="!!purchase" :purchase="purchase" />
</template>

<script>

  import PurchaseTracking from "./PurchaseTracking.vue";
  import PurchaseManufacturerInfo from "./PurchaseManufacturerInfo.vue";
  import PurchaseSummary from "./PurchaseSummary.vue";

  export default {
    name: "PurchaseFooter",
    components: {
      PurchaseTracking,
      PurchaseManufacturerInfo,
      PurchaseSummary
    },
    props: {
      purchase: {
        type: Object,
        default: null,
      },
    },  
    computed: {
      tracking(){
        return this.$store.state.purchase.purchaseTracking.data;
      }
    },
    watch: {
      purchase(val) {
        if(val){
          this.$store.commit("purchase/getTracking", val._id);
        }
      }
    },
  };

</script>